import { useState, useEffect } from "react";
import '../css/enemy.css';


const EnemyWrapper = ({ passEnemyStats }) => {
  const [enemyDEF, setDEF] = useState(300);
  const [enemyRES, setRES] = useState(20);
  const [areaBonus, setAreaBonus] = useState(30);
  const [defResSelection, setDefResSelection] = useState("Raid Bosses (300/20)");
  const [areaSelection, setAreaSelection] = useState("Reccomended Element Bonus (30)");

  // Fixed presets
  const defResPresets = {
    "Raid Bosses (300/20)": { DEF: 300, RES: 20 },
    "Story Mode Enemies (200/20)": { DEF: 200, RES: 20 },
    Custom: null,
  };

  const areaPresets = {
    "Reccomended Element Bonus (30)": 30,
    "No Bonus (0)": 0,
    Custom: null,
  };

  useEffect(() => {
    if (defResSelection !== "Custom") {
      const preset = defResPresets[defResSelection];
      setDEF(preset.DEF);
      setRES(preset.RES);
    }
  }, [defResSelection]);

  useEffect(() => {
    if (areaSelection !== "Custom") {
      setAreaBonus(areaPresets[areaSelection]);
    }
  }, [areaSelection]);

  // Push stats upward
  useEffect(() => {
    passEnemyStats({ DEF: enemyDEF, RES: enemyRES, area: areaBonus });
  }, [enemyDEF, enemyRES, areaBonus, passEnemyStats]);

  return (
    <div className="enemyWrapper">
      {/* DEF + RES */}
      <div className="enemyStatWrapper">
        <div className="enemyTitle">Enemy Defense & Elemental Resistance</div>
        <select
          value={defResSelection}
          onChange={(e) => setDefResSelection(e.target.value)}
          className="enemyDropdown"
        >
          {Object.keys(defResPresets).map((key) => (
            <option key={key} value={key}>
              {key}
            </option>
          ))}
        </select>

        {defResSelection === "Custom" && (
          <div className="enemyStatCustom">
            <div>
              <label className="enemyStatTitle">DEF:</label>
              <input
                type="number"
                value={enemyDEF}
                onChange={(e) => setDEF(Number(e.target.value))}
                className="enemyCustomInput"
              />
            </div>
            <div>
              <label className="enemyStatTitle">RES:</label>
              <input
                type="number"
                value={enemyRES}
                onChange={(e) => setRES(Number(e.target.value))}
                className="enemyCustomInput"
              />
            </div>
          </div>
        )}
      </div>

      {/* Area Bonus */}
      <div className="areaWrapper">
        <div className="enemyTitle">Area Bonus</div>
        <select
          value={areaSelection}
          onChange={(e) => setAreaSelection(e.target.value)}
          className="enemyDropdown"
        >
          {Object.keys(areaPresets).map((key) => (
            <option key={key} value={key}>
              {key}
            </option>
          ))}
        </select>

        {areaSelection === "Custom" && (
          <div className="enemyStatCustom">
            <label className="enemyStatTitle">Custom Bonus:</label>
            <input
              type="number"
              value={areaBonus}
              onChange={(e) => setAreaBonus(Number(e.target.value))}
              className="enemyCustomInput"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EnemyWrapper;
